/** Join truthy class names */
export const cx = (...parts) => parts.filter(Boolean).join(' ');

/** Clipboard copy with a fallback for non-secure contexts */
export async function copyText(text) {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      /* fall through to legacy path */
    }
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    ta.remove();
    return ok;
  } catch {
    return false;
  }
}

/** Safe JSON.parse with a fallback */
export function safeParse(text, fallback) {
  try {
    return JSON.parse(text);
  } catch {
    return fallback;
  }
}

/** Compact "Jul 8, 4:35 PM" style timestamp */
export function formatTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

/** Human breakdown of a shift's items_sold_json */
export function shiftBreakdown(itemsSoldJson) {
  const items = safeParse(itemsSoldJson, []);
  if (!Array.isArray(items) || items.length === 0) return '—';
  return items.map((it) => `${it.name} ×${it.qty}`).join(', ');
}